import { ECommercialOriginType } from "../../Enum/ECommercialOriginType"

export class AdminCommercialPerformanceSummary {
  totalSubscriptions: number

  totalMonthlyRecurringRevenue: number

  topOriginByConversion: ECommercialOriginType

  topOriginSubscriptionsCount: number

  constructor(data: Partial<AdminCommercialPerformanceSummary> = {}) {
    this.totalSubscriptions = data.totalSubscriptions ?? 0

    this.totalMonthlyRecurringRevenue = data.totalMonthlyRecurringRevenue ?? 0

    this.topOriginByConversion = data.topOriginByConversion ?? ECommercialOriginType.Undefined

    this.topOriginSubscriptionsCount = data.topOriginSubscriptionsCount ?? 0
  }
}
